import { render, staticRenderFns } from "./RecipeNew.vue?vue&type=template&id=b74cdf44&"
import script from "./RecipeNew.vue?vue&type=script&lang=js&"
export * from "./RecipeNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports